import React from 'react'
import styles from '../modalComponent.module.scss'
import TextArea from '../../../../UiKitComponents/TextArea'
import {
  setConfirmationModalForm,
  setConfirmationModalFormErrorMessage,
} from '../../../../../redux/actions/confirmationModal'
import { useDispatch, useSelector } from 'react-redux'
import Checked from '../../../../../icons/checked.svg'
import UnChecked from '../../../../../icons/unChecked.svg'
import cx from 'classnames'
import ErrorIcon from '../../../../../icons/errorIcon.svg'

const CancelSubscription = () => {
  const dispatch = useDispatch()
  const { form, formErrors } = useSelector((state) => state.confirmationModal)
  const reasonsList = [
    {
      value: 'REASON_1',
      label: 'Ich benötige das Abonnement nicht länger.',
    },
    {
      value: 'REASON_2',
      label: 'Es ist mir zu teuer.',
    },
    {
      value: 'REASON_3',
      label: 'Ich hatte technische Probleme.',
    },
    {
      value: 'REASON_4',
      label: 'Ich möchte es lieber selbst machen.',
    },
  ]

  const handleCommentsChange = (field, value) => {
    dispatch(
      setConfirmationModalFormErrorMessage({ ...formErrors, [field + 'Error']: '' }),
    )
    const newForm = {
      ...form,
      [field]: value,
    }
    dispatch(setConfirmationModalForm(newForm))
  }
  const handleReasonChange = (field, value) => {
    dispatch(
      setConfirmationModalFormErrorMessage({ ...formErrors, [field + 'Error']: '' }),
    )
    const newForm = {
      ...form,
      [field]: value,
    }
    dispatch(setConfirmationModalForm(newForm))
  }
  return (
    <section className={styles.cancelSub}>
      <p>
        Ihr Abonnement wird nicht verlängert, bleibt jedoch bis zum Ende des
        aktuellen Abrechnungszeitraums aktiv.
      </p>
      <div>
        <h3>Weshalb möchten Sie das Abonnement kündigen?</h3>
        <div>
          {reasonsList.map((reason) => {
            return (
              <div key={reason.value}>
                <img
                  src={reason.value === form.reason ? Checked : UnChecked}
                  alt={'SelectReason'}
                  onClick={() => handleReasonChange('reason', reason.value)}
                />
                <span>{reason.label}</span>
              </div>
            )
          })}
        </div>
        {formErrors.reasonError ? (
          <div className={cx(styles.errorMessage)}>
            <img src={ErrorIcon} alt={ErrorIcon} />
            <span>{formErrors.reasonError}</span>
          </div>
        ) : null}
      </div>
      <TextArea
        name="comment"
        rows={3}
        label={'Sonstiges, das Sie mit uns teilen möchten?'}
        value={form.value}
        onChange={(e) => handleCommentsChange('comment', e.currentTarget.value)}
        marginBottom
      />
    </section>
  )
}
export default CancelSubscription
